import React, {
  useRef,
  useState,
  useEffect,
  useMemo,
} from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { selectLocale } from 'models/localization';
import { selectLocalizedEventName } from 'models/virtual_event';
import ParticipantListContainer from './ParticipantListContainer';
import ParticipantFilterSwitch from './filter/ParticipantFilterSwitch';

const RootContainer = styled.div`
  display: flex;
  height: 100%;
  overflow: hidden;
  flex-direction: row;
  -webkit-overflow-scrolling: touch;
  background-color: #F0F2F5;

  @media (min-width: 960px) {
    position: relative;
    justify-content: space-between;
  }

  @media (max-width: 960px) {
    width: 100%;
    background-color: #F0F1F2;
    flex-direction: column;
  }
`;

const PageContentContainer = styled.div`
  flex: 1 0 auto;
  max-width: 100%;
  flex-direction: column;
  height: 100%;
  overflow: auto;

  @media (min-width: 959px) {
    display: flex;
    flex-wrap: wrap;
    padding: 8px 16px;
    max-width: 100%;
  }
`;

const FilterContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;

  @media (min-width: 959px) {
    flex-direction: 0;
  }
`;

const ParticipantPageContainer = () => {
  const { t } = useTranslation();
  const locale = useSelector(selectLocale);
  const { pageNames: { participant }, features } = useSelector((state: any) => state.eventConfigs);
  const [scrollableTarget, setScrollableTarget] = useState();
  const eventName = useSelector(selectLocalizedEventName);
  const pageWrapperRef = useRef();

  useEffect(() => {
    setScrollableTarget(pageWrapperRef.current);
  }, []);

  const pageTitle = participant?.[locale] || t('page.participants', 'Participants');

  return (
    <RootContainer>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{`${pageTitle} | ${eventName}`}</title>
        <meta name="description" content={`${pageTitle} page of ${eventName}.`} />
      </Helmet>
      <FilterContainer>
        <ParticipantFilterSwitch />
      </FilterContainer>
      <PageContentContainer ref={pageWrapperRef}>
        <ParticipantListContainer
          scrollableTarget={scrollableTarget}
        />
      </PageContentContainer>
    </RootContainer>
  );
};

export default ParticipantPageContainer;
